import { S1WhatifScheduleID } from "./s1-scheduledId";
import { S1DownloadRequestInfo } from "./s1-whatifDownloadInfo";

export class ServerDownloadRequest {
    scheduleId: S1WhatifScheduleID;
    requestInfo: S1DownloadRequestInfo;
}